import { useState } from 'react';
import Table from '../../ui/Table';
import { microtaskTypeData } from '../bounties/microtasktypes/microtaskTypeData';
import ExpandedImage from '../../ui/ExpandedImage';
import Feedbackclose from '../../assets/icons/Feedbackclose';
import Button from '../../ui/Button';
import { PhotoMetadata } from './PhotoMetaData';

const UploadVideoSD = ({ dataTask }) => {
    const titleObject = dataTask?.task.find((obj) => Object.keys(obj).includes('Title'));
    const descriptionObject = dataTask?.task.find((obj) => Object.keys(obj).includes('Description'));

    const [isModalOpen, setIsModalOpen] = useState(false);
    const { timestamps, latitudes, longitudes } = dataTask?.submission || {};

    // const goToNext = () => {
    //     setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    // };

    // const goToPrev = () => {
    //     setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
    // };

    // const goToIndex = (index) => {
    //     setCurrentIndex(index);
    // };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <Table.Row>
            <p className=" text-textPrimary flex flex-col   ">
                <span className="font-medium mb-1  "> {titleObject?.Title || '-'} </span>
                <span className="text-xs font-medium mb-1">{descriptionObject?.Description || '-'}</span>
            </p>
            <p className="text-sm justify-self-center">
                {microtaskTypeData.find((ele) => ele.type === dataTask.actionType).label}
            </p>
            <div>
                {dataTask?.files?.[0] ? (
                    <div className="flex justify-center rounded-xl overflow-hidden">
                        <video
                            onClick={openModal}
                            controls
                            className="w-full h-32 object-contain cursor-pointer rounded-lg shadow-lg"
                        >
                            <source src={dataTask?.files[0]} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                ) : (
                    <span className=" text-textSecondary mb-1 ">Not answered</span>
                )}

                {timestamps && latitudes && longitudes && (
                    <PhotoMetadata
                        timestamp={timestamps[0][0]}
                        latitude={latitudes[0][0]}
                        longitude={longitudes[0][0]}
                        className=""
                    />
                )}
            </div>

            {isModalOpen && (
                <ExpandedImage close={closeModal}>
                    <div
                        className="relative w-full max-w-4xl h-[450px] bg-grayBgNormal rounded-md overflow-hidden flex flex-col items-center justify-center"
                        style={{ aspectRatio: '16/9', minHeight: '360px' }}
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
                    >
                        <Button
                            radius="rounded-full"
                            onClick={closeModal}
                            className=" border-0  absolute top-3  right-4 "
                            variant="tertiary"
                            size="circle"
                        >
                            <Feedbackclose />
                        </Button>

                        <div className="flex justify-center rounded-xl overflow-hidden">
                            <video
                                controls
                                className="object-contain w-full h-full rounded-lg shadow-lg"
                                style={{ background: '#000' }}
                            >
                                <source src={dataTask?.files[0]} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        {timestamps && latitudes && longitudes && (
                            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-10 bg-grayBgNormal bg-opacity-80 rounded px-4 py-2">
                                <PhotoMetadata
                                    timestamp={timestamps[0][0]}
                                    latitude={latitudes[0][0]}
                                    longitude={longitudes[0][0]}
                                    isShowTooltip={false}
                                    className=""
                                />
                            </div>
                        )}

                        {/* <button
                            onClick={goToPrev}
                            className="absolute left-0 top-1/2 transform -translate-y-1/2 px-4 py-2 text-white rounded-full "
                        >
                            <ArrowLeft w="16" h="16" />
                        </button> */}

                        {/* <button
                            onClick={goToNext}
                            className="absolute right-0 top-1/2 transform -translate-y-1/2 px-4 py-2 text-white rounded-full"
                        >
                            <ArrowRight w="16" h="16" />
                        </button> */}
                    </div>
                </ExpandedImage>
            )}
        </Table.Row>
    );
};

export default UploadVideoSD;
